import { tokens } from '@neo4j-ndl/base';
import { Typography } from '@neo4j-ndl/react';
import { ChevronRightIconOutline } from '@neo4j-ndl/react/icons';
import { isNotNullish } from '@nx/stdlib';

import { PropertyDisplay } from '../shared/components/property-display';

interface DeploymentConfigItemProps {
  serverId: string;
  serverName: string;
  neo4jConfig: Record<string, string | number | boolean>;
  filter: string;
  isOpen: boolean;
  toggleIsOpen: (serverId?: string, isOpen?: boolean) => void;
}

export const DeploymentConfigItem = ({
  serverId,
  serverName,
  neo4jConfig,
  filter,
  isOpen,
  toggleIsOpen,
}: DeploymentConfigItemProps) => {
  return (
    <div key={serverId}>
      <div
        role="button"
        tabIndex={0}
        aria-label="Toggle Servers"
        aria-pressed={isOpen}
        onKeyDown={(e) => e.key === 'Enter' && toggleIsOpen(serverId)}
        className="text-palette-neutral-text-weak flex cursor-pointer items-center gap-2"
        onClick={() => toggleIsOpen(serverId)}
        data-testid={`server-button-${serverId}`}
      >
        <ChevronRightIconOutline
          aria-label="Show Servers"
          className="size-4"
          style={{
            transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
            transitionDuration: tokens.transitions.values.duration.quick,
          }}
        />
        <Typography variant="subheading-small" className="mr-2">
          <PropertyDisplay label={'Server'} text={`${serverName}`}></PropertyDisplay>
        </Typography>
      </div>
      {isOpen && (
        <div style={{ columnGap: '5%' }} className="grid gap-1 pl-4 pt-2">
          {Object.keys(neo4jConfig)
            .filter((key) => {
              return filter === '' || key.includes(filter);
            })
            .map((key) => {
              return (
                <div className="grid grid-cols-2 gap-4" key={`${serverId}-${key}`}>
                  <Typography
                    key={`${serverId}-${key}-key`}
                    variant="label"
                    className="text-neutral-text-weak text-wrap break-words"
                  >
                    {key}:
                  </Typography>
                  <Typography
                    key={`${serverId}-${key}-value`}
                    variant="body-medium"
                    className="text-neutral-text-weaker text-wrap break-words"
                  >
                    {`${isNotNullish(neo4jConfig[key]) && neo4jConfig[key] !== '' ? neo4jConfig[key] : '-'}`}
                  </Typography>
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
};
